import EventRepository from '@/repositories/EventRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { UchinokoData } from '@/types/domain/uchinoko'

export interface ISearchEventCartQueryPhotosUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
}

export default class SearchEventCartQueryPhotosUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ eventRepository, snapsnapGateway }: ISearchEventCartQueryPhotosUseCaseParams) {
    this.eventRepository = eventRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { eventId: number; isClear?: boolean; recommend?: boolean }): Promise<UchinokoData[]> {
    try {
      const { eventId, isClear, recommend } = params
      if (!isClear) {
        const data = await this.snapsnapGateway.C4.eventCartQuerySearch({ eventId, recommend })
        this.eventRepository.saveUchinokoData({ eventId, data })
        return data
      } else {
        // APIを叩かず初期値に戻す
        const data: UchinokoData[] = []
        this.eventRepository.saveUchinokoData({ eventId, data })
        return data
      }
    } catch (error) {
      throw error
    }
  }
}
